import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import {
  Search,
  ShoppingCart,
  User,
  Menu,
  X,
  LogOut,
} from 'lucide-react';
import { Outlet } from 'react-router-dom';
import Footer from './Footer';
import { useSelector } from 'react-redux';

import { useDispatch } from 'react-redux';

import {
  setLoginStatus,
  setUserDetails,
  setUserId,
} from '../redux/authSlice';

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState('');
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  // const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);

  const loggedInStatus = useSelector(
    (state) => state.auth.loggedInStatus
  );
  const userDetails = useSelector((state) => state.auth.userDetails);

  // Check if user is logged in on component mount
  // useEffect(() => {
  //   const loggedInStatus = localStorage.getItem('isLoggedIn');
  //   if (loggedInStatus === 'true') {
  //     setIsLoggedIn(true);
  //   }
  // }, []);

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleUserDropdown = () => {
    setUserDropdownOpen(!userDropdownOpen);
  };

  const handleLogout = () => {
    dispatch(setLoginStatus(false));
    dispatch(setUserDetails({}));
    dispatch(setUserId(''));

    // localStorage.removeItem('isLoggedIn');
    // localStorage.removeItem('user');
    // setIsLoggedIn(false);
    setUserDropdownOpen(false);
    navigate('/');
  };

  return (
    <div className='min-h-screen flex flex-col'>
      <header
        className={`fixed w-full z-50 transition-all duration-300 ${
          isScrolled
            ? 'bg-emerald-600 text-white shadow-md py-2'
            : 'bg-emerald-500 text-white py-4'
        }`}
      >
        <div className='container mx-auto px-4'>
          {/* Desktop Navigation */}
          <div className='flex items-center justify-between'>
            {/* Logo */}
            <Link to='/' className='flex items-center'>
              <h1 className='text-2xl font-bold text-white transition-all duration-300 hover:text-gray-100'>
                Pralhad Flours
              </h1>
            </Link>

            {/* Desktop Menu */}
            <nav className='hidden md:flex items-center space-x-6'>
              <Link
                to='/'
                className='text-white hover:text-gray-200 transition-all duration-200 font-medium hover:scale-105'
              >
                Home
              </Link>
              <Link
                to='/products'
                className='text-white hover:text-gray-200 transition-all duration-200 font-medium hover:scale-105'
              >
                Products
              </Link>
              <Link
                to='/aboutus'
                className='text-white hover:text-gray-200 transition-all duration-200 font-medium hover:scale-105'
              >
                About Us
              </Link>
              <Link
                to='/contact'
                className='text-white hover:text-gray-200 transition-all duration-200 font-medium hover:scale-105'
              >
                Contact
              </Link>
            </nav>

            {/* Search Box */}
            {/* <div className='hidden md:flex items-center relative flex-1 max-w-md mx-6'>
              <input
                type='text'
                value={searchTerm}
                onChange={handleSearchChange}
                placeholder='Search products...'
                className='w-full px-4 py-2 rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-300'
              />
              <button className='absolute right-3 text-gray-500 hover:text-green-600 transition-colors duration-200'>
                <Search size={20} />
              </button>
            </div> */}

            {/* Cart and Profile */}
            <div className='flex items-center space-x-4'>
              {loggedInStatus && (
                <Link
                  to='/myorders'
                  className='relative p-2 text-gray-600 hover:text-[white] transition-all duration-200 hover:scale-110'
                >
                  <span className='font-medium'>My Order</span>
                </Link>
              )}

              {/* User Profile / Login */}
              {loggedInStatus ? (
                <div className='relative'>
                  <button
                    onClick={toggleUserDropdown}
                    className='p-2 text-white hover:text-gray-200 transition-all duration-200 hover:scale-110 flex items-center'
                  >
                    <User size={24} />
                    <span className='ml-2 hidden md:inline'>
                      {userDetails?.name || 'User'}
                    </span>
                  </button>

                  {/* User Dropdown */}
                  {userDropdownOpen && (
                    <div className='absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50'>
                      <Link
                        to='/profile'
                        className='block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100'
                        onClick={() => setUserDropdownOpen(false)}
                      >
                        Profile
                      </Link>
                      <Link
                        to='/myorders'
                        className='block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100'
                        onClick={() => setUserDropdownOpen(false)}
                      >
                        My Orders
                      </Link>
                      <button
                        onClick={handleLogout}
                        className='block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100'
                      >
                        <div className='flex items-center'>
                          <LogOut size={16} className='mr-2' />
                          Logout
                        </div>
                      </button>
                    </div>
                  )}
                </div>
              ) : (
                <div className='flex items-center space-x-2'>
                  <Link
                    to='/login'
                    className='text-white hover:text-gray-200 transition-all duration-200 hover:scale-105 px-4 py-1 border border-white rounded-full'
                  >
                    Login
                  </Link>
                  <Link
                    to='/register'
                    className='hidden md:inline-block text-emerald-600 bg-white hover:bg-gray-100 transition-all duration-200 hover:scale-105 px-4 py-1 rounded-full'
                  >
                    Register
                  </Link>
                </div>
              )}

              {/* Mobile Menu Button */}
              <button
                className='md:hidden p-2 text-white hover:text-gray-200 transition-all duration-200'
                onClick={toggleMobileMenu}
              >
                {isMobileMenuOpen ? (
                  <X size={24} />
                ) : (
                  <Menu size={24} />
                )}
              </button>
            </div>
          </div>

          {/* Mobile Search Bar */}
          <div className='md:hidden mt-3'>
            <div className='relative'>
              <input
                type='text'
                value={searchTerm}
                onChange={handleSearchChange}
                placeholder='Search products...'
                className='w-full px-4 py-2 rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-300'
              />
              <button className='absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-green-600 transition-colors duration-200'>
                <Search size={20} />
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Navigation Menu */}
        <div
          className={`md:hidden bg-white absolute w-full left-0 shadow-lg transition-all duration-300 ${
            isMobileMenuOpen
              ? 'max-h-screen opacity-100'
              : 'max-h-0 opacity-0 overflow-hidden'
          }`}
        >
          <nav className='flex flex-col py-4 px-4'>
            <Link
              to='/'
              className='py-2 px-4 text-gray-700 hover:bg-green-50 hover:text-green-600 transition-all duration-200'
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Home
            </Link>
            <Link
              to='/products'
              className='py-2 px-4 text-gray-700 hover:bg-green-50 hover:text-green-600 transition-all duration-200'
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Products
            </Link>
            <Link
              to='/aboutus'
              className='py-2 px-4 text-gray-700 hover:bg-green-50 hover:text-green-600 transition-all duration-200'
              onClick={() => setIsMobileMenuOpen(false)}
            >
              About Us
            </Link>
            <Link
              to='/contact'
              className='py-2 px-4 text-gray-700 hover:bg-green-50 hover:text-green-600 transition-all duration-200'
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Contact
            </Link>

            {/* Mobile Login/Register links */}
            {!loggedInStatus && (
              <>
                <Link
                  to='/login'
                  className='py-2 px-4 text-gray-700 hover:bg-white-50 hover:text-green-600 transition-all duration-200'
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Login
                </Link>
                <Link
                  to='/register'
                  className='py-2 px-4 text-gray-700 hover:bg-green-50 hover:text-green-600 transition-all duration-200'
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Register
                </Link>
              </>
            )}

            {/* Mobile Logout */}
            {loggedInStatus && (
              <>
                <Link
                  to='/profile'
                  className='py-2 px-4 text-gray-700 hover:bg-green-50 hover:text-green-600 transition-all duration-200'
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Profile
                </Link>
                <Link
                  to='/myorders'
                  className='py-2 px-4 text-gray-700 hover:bg-green-50 hover:text-green-600 transition-all duration-200'
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  My Orders
                </Link>
                <button
                  onClick={() => {
                    handleLogout();
                    setIsMobileMenuOpen(false);
                  }}
                  className='py-2 px-4 text-gray-700 hover:bg-green-50 hover:text-green-600 transition-all duration-200 text-left w-full flex items-center'
                >
                  <LogOut size={16} className='mr-2' />
                  Logout
                </button>
              </>
            )}
          </nav>
        </div>
      </header>
      <main className='flex-grow w-[100%] mx-auto px-4 pb-8'>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Header;
